<div
  class="dropdown-root"
  tabindex="0"
  (keydown)="onKeyDown($event)"

>
  <button
    #triggerBtn
    class="dropdown-trigger"
    type="button"
    (click)="toggleMenu()"
    [attr.aria-expanded]="menuOpen"
  >
    <img
      class="dropdown-avatar-img"
      *ngIf="avatarUrl"
      [src]="avatarUrl"
      alt="User avatar"
      referrerpolicy="no-referrer"
    />
    <span class="dropdown-avatar" *ngIf="!avatarUrl && userLabel">{{
      userLabel.charAt(0)
    }}</span>
    <!-- <span class="dropdown-label" *ngIf="userLabel">{{ userLabel }}</span> -->
    <!-- <svg class="dropdown-caret" viewBox="0 0 20 20">
      <path
        d="M6 8l4 4 4-4"
        stroke="currentColor"
        stroke-width="2"
        fill="none"
      />
    </svg> -->
  </button>
</div>
